<div class="container">
    <div class="row mt-3">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb fqg f18">
                <li class="mr-3">
                    <a href="/index"><img src="/assets/images/icon-yurt.png" alt="home"></a>
                </li>
                <li aria-current="page" class="breadcrumb-item">
                    <a (click)="goBack()">
                        <span class="mgl">ᠨᠣᠮ ᠤᠨ ᠣᠪᠣᠭᠠᠨ ᠤ ᠰᠢᠷᠢᠰ ᠠᠵᠢᠯᠯᠠᠭ᠎ᠠ</span>
                    </a>
                </li>
                <li aria-current="page" class="breadcrumb-item active"><span class="mgl">{{saDetailed.title}}</span></li>
            </ol>
        </nav>
    </div>
    <div *ngIf="saDetailed.videoFiles.length !== 0">
        <video id='my-video' controls controlslist="nodownload" class='video-js vjs-big-play-centered' preload='auto' data-setup='{}'>
            <source src='{{url + saDetailed.videoFiles[0].path}}' type='video/mp4'>
        </video>
    </div>
    <div *ngIf="saDetailed.videoFiles.length === 0 && saDetailed.mediaFiles.length !== 0" class="bg-white rounded-lg">
        <div id="pills-tabContent" class="tab-content">
            <div id="script-1" role="tabpanel" aria-labelledby="script-1-tab" class="tab-pane fade show active">
                <div class="row p-5 mb-5">
                    <div class="col-1 pt-4 pb-5">
                        <h4 class="mgl fgq f24 ml-0">{{saDetailed.title}}</h4>
                    </div>
                    <div class="col-11 pt-4 pb-4 pr-3">
                        <div class="simg">
                            <div class="simg_max">
                                <img nz-image alt="" class="img_100 hp" nzSrc="{{url + aImage}}">
                            </div>
                            <div class="d-flex simg_min">
                                <div class="sm_item hp" [ngClass]="{'si_active': ai === i}" *ngFor="let img of images;let i = index">
                                    <img class="img_max_100" src="{{url + img.path}}" alt="" (click)="aI(i, img.path)">
                                </div>
                            </div>
                        </div>
                        <div class="col pl-0 pb-3 overflow-auto">
                            <div class="mgl fqg f18 mt-5 ml-0 mb-0 s_content">{{saDetailed.content}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>